import { PartialBrief } from '../../../../Types/Brief'
import { getSymbolForCurrency } from '../../../../Utilities/currencySymbol'
import {
  dateToReadableString,
  timeOptionToReadableString,
  areSameDay,
} from '../../../FormSteps/DateTime/Utilities/dateStrings'
import { getBriefDates } from '../../../FormSteps/DateTime/Utilities/getBriefDates'
import { eventTypeLabels } from '../../../FormSteps/EventType/EventTypeInput'
import { capitaliseLayout } from '../../../FormSteps/Layout/LayoutInput'

export const formatAsQuote = (text?: string | null): string => {
  const trimmedText = text?.trim()

  return trimmedText ? `"${trimmedText}"` : 'None'
}

export const formatLayout = ({ layouts }: PartialBrief): string | undefined => {
  if (!layouts) return undefined

  return layouts === 'not_sure' ? 'Not sure' : capitaliseLayout(layouts)
}

export const formatTimings = (brief: PartialBrief) => {
  const dates = getBriefDates(brief)
  const [_startDate, _endDate] = dates
  const startDate = _startDate && dateToReadableString(_startDate)
  const endDate = _endDate && dateToReadableString(_endDate)
  const startTime = brief.fromTime && timeOptionToReadableString(brief.fromTime)
  const endTime = brief.toTime && timeOptionToReadableString(brief.toTime)

  return areSameDay(dates)
    ? `${startDate}, ${startTime} - ${endTime}`
    : `${startDate} at ${startTime} - ${endDate} at ${endTime}`
}

export const formatBudget = (brief: PartialBrief) =>
  `${getSymbolForCurrency(brief.currency ?? undefined)}${brief.budget}`

export const formatEventType = (brief: PartialBrief) => eventTypeLabels[brief.collectionName ?? '']
